"use client";
import { type ReactNode, useEffect } from "react";
import clsx from "clsx";
import { useState } from "react";
import { ChevronUp } from "@/components/newIcons/ChevronUp";

type Props = {
  title: string;
  icon: ReactNode;
  isInitOpen?: boolean;
  children: ReactNode;
};
export const Collapse = ({ title, icon, children, isInitOpen }: Props) => {
  const [isOpen, setIsOpen] = useState(isInitOpen);

  useEffect(() => {
    setIsOpen(isInitOpen);
  }, [isInitOpen]);

  return (
    <div className="border border-[#E5E5E5] rounded-[5px] mt-5 p-5">
      <div className="flex items-center cursor-pointer select-none" onClick={() => setIsOpen(!isOpen)}>
        {icon}
        <p
          className={clsx("text-primary text-sm lg:text-base lg:leading-5 font-bold px-[10px]", {
            "line-clamp-1": !isOpen,
          })}
        >
          {title}
        </p>
        <div className="grow" />
        <p className="font-semibold text-primary text-sm pr-0.5">{isOpen ? "FERMER" : "OUVRIR"}</p>
        <ChevronUp
          className={clsx("w-4 h-4 transition-all text-primary", {
            "rotate-180": !isOpen,
          })}
        />
      </div>
      {isOpen && <div className="mt-5">{children}</div>}
    </div>
  );
};
